import { warn } from '@ali/re-utils';
import Types from '../types';

export default class Scalar {
  constructor(data, owner, type) {
    this.data = data;
    this.type = type;
    this.owner = owner;
  }

  isNumber() {
    return this.type === Types.NUMBER;
  }

  isString() {
    return this.type === Types.STRING;
  }

  isBool() {
    return this.type === Types.BOOL;
  }

  into(data, type = null) {
    if (!type) {
      type = Types.test(data);
    }
    const origData = this.data;
    switch (type) {
      case Types.STRING:
      case Types.BOOL:
      case Types.NUMBER:
        this.data = data;
        this.type = type;
        break;
      case Types.NULL:
        this.toNull();
        break;
      default:
        warn(`Scalar cannot receive data of type "${type}"`, data);
        break;
    }

    if (origData !== this.data) {
      this.owner.statChange();
    }
    return origData !== this.data;
  }

  toNull() {
    if (this.type === Types.BOOL) {
      this.data = false;
    } else if (this.type === Types.STRING) {
      this.data = '';
    } else {
      this.data = null;
    }
  }

  toJS() {
    return this.data;
  }

  valueOf() {
    return this.toJS();
  }

  toString() {
    return this.data.toString();
  }

  size() {
    return this.toString().length;
  }

  clear() {
    const origData = this.data;
    this.toNull();
    if (origData !== this.data) {
      this.owner.statChange();
    }
  }
}
